import { render, staticRenderFns } from "./Appendix4.vue?vue&type=template&id=c56702f0&scoped=true&"
import script from "./Appendix4.vue?vue&type=script&lang=js&"
export * from "./Appendix4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56702f0",
  null
  
)

export default component.exports